module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-play"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper video-play__wrapper"
  }, [_c('div', {
    staticClass: "video-play__wrapper--inner"
  }, [(_vm.returnedVideo) ? _c('video', {
    ref: "videoEl",
    staticClass: "video-play__video",
    attrs: {
      "id": ("video-" + (_vm.returnedVideo.id)),
      "controls": "true",
      "preload": "auto"
    },
    on: {
      "ended": _vm.showCredits,
      "timeupdate": _vm.checkVideoCompletion
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.returnedVideo.url,
      "type": "video/mp4"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper mt-4"
  }, [_c('div', {
    staticClass: "video-play__options-bar"
  }, [_c('div', {
    staticClass: "video-play__options--left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "video-play__home-link",
    attrs: {
      "src": require("../assets/BTAB_one_line.svg"),
      "alt": "Britain Take A Bow"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "video-play__options--right"
  }, [_c('button', {
    staticClass: "button video-play__button",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Load a new version")]), _vm._v(" "), _c('p', {
    staticClass: "video-play__link video-play__credits-link",
    on: {
      "click": _vm.showCredits
    }
  }, [_vm._v("Credits")])])])])]), _vm._v(" "), _c('credits', {
    attrs: {
      "displayCredits": _vm.displayCredits,
      "creditData": _vm.creditData,
      "reload": _vm.reload,
      "hideCredits": _vm.hideCredits,
      "replayVideo": _vm.replayVideo,
      "typoCredit": _vm.typographyCredit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a8f23de","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video-play.vue
// module id = 219
// module chunks = 1